import { css } from '@emotion/react'
import { useState } from 'react'
import { observer, inject } from 'mobx-react'
import { useField } from 'react-final-form'

import { CircleNegative, CirclePlus } from '../../../../assets/icons'
import { SVGWrapper, SliderWithValueUnderneath, Spacer } from '../../../../components'
import { Page } from '../style'
import { numberToDollars } from '../../../../utils/utils'
import HelpIcon from '../../../../components/HelpIcon'
import TooltipText from '../../../../components/TooltipText'

function AddAnEmergencyFund(props) {
  const {
    store: { totalPrimaryBalanceExcludingPensionAndAnnuity, emergencyFund },
  } = props
  const [open, setOpen] = useState(false)
  return (
    <Page.ConsiderationWrapper>
      <Page.ConsiderationContainer onClick={() => setOpen(!open)}>
        <SVGWrapper
          css={css`
            margin-right: 10px;
          `}
          svg={open ? CircleNegative : CirclePlus}
          fill='#3A4D57'
          size='large'
        />
        <Page.ConsiderationLabel>Add an emergency fund</Page.ConsiderationLabel>
      </Page.ConsiderationContainer>
      {open && (
        <>
          <Spacer space='5px' />
          <Page.EmergencyAmountText>
            (amount taken from investment balance &nbsp;
            <HelpIcon size='medium' tooltip={TooltipText.emergencyFundHelp()} />)
          </Page.EmergencyAmountText>
          <Page.ConsiderationBody>
            <Page.SliderContainer
              css={css`
                margin: 20px 0;
                align-items: flex-start;
              `}>
              <Page.SliderLabel>
                <EmergencyFundInputField
                  fieldName='emergencyFundInput'
                  maxValue={totalPrimaryBalanceExcludingPensionAndAnnuity}
                />
              </Page.SliderLabel>
              <Page.SliderValue>
                <EmergencyFundSliderField
                  totalPrimaryBalanceExcludingPensionAndAnnuity={
                    totalPrimaryBalanceExcludingPensionAndAnnuity
                  }
                  fieldName='emergencyFundSlider'
                  emergencyFund={emergencyFund.amount}
                />
              </Page.SliderValue>
            </Page.SliderContainer>
          </Page.ConsiderationBody>
        </>
      )}
    </Page.ConsiderationWrapper>
  )
}

export default inject('store', 'main')(observer(AddAnEmergencyFund))

const EmergencyFundSliderField = ({
  fieldName,
  totalPrimaryBalanceExcludingPensionAndAnnuity,
  emergencyFund,
}) => {
  const { input } = useField(fieldName, {
    subscription: { value: true, touched: true, error: true },
  })
  return (
    <SliderWithValueUnderneath
      min='0'
      max={totalPrimaryBalanceExcludingPensionAndAnnuity}
      value={input.value}
      onChange={input.onChange}
      step='100'
      frozenValue={emergencyFund}
      displayValue={false}
    />
  )
}

const EmergencyFundInputField = ({ fieldName, maxValue }) => {
  const { input, meta } = useField(fieldName, {
    subscription: { value: true, touched: true, error: true },
    validate: value => {
      if (value > maxValue) {
        return `Cannot exceed available balance of $${numberToDollars(Number(maxValue), true)}`
      }
      return undefined
    },
  })

  const handleChange = e => {
    const cleanedValues = Number(e.target.value.replace(/\D/g, '')) ?? 0
    input.onChange(cleanedValues)
  }

  return (
    <Page.EmergencyFundInputFieldContainer>
      <Page.EmergencyInput
        {...input}
        value={numberToDollars(Number(input.value), true)}
        onChange={handleChange}
        maxLength={10}
      />
      {meta.error && (
        <Page.EmergencyInputValidationError>{meta.error}</Page.EmergencyInputValidationError>
      )}
    </Page.EmergencyFundInputFieldContainer>
  )
}
